export default "__VITE_ASSET__ed6feb69__"